import { useEffect, useState } from "react";
import { debounce } from "../utils/debounce";
import { canUseDOM } from "../utils";

const useScrollListener = (isDisabled = false) => {
  const [scrollData, setScrollData] = useState({
    scrollDirection: null,
    pageOffset: canUseDOM() ? window.pageYOffset: 0
  });

  const handleScrollData = debounce(() => {
    const currentPageOffset = window.pageYOffset;

    setScrollData(({ scrollDirection, pageOffset }) => {
      return {
        scrollDirection:
          pageOffset !== null && pageOffset < currentPageOffset ? "down" : "up",
        pageOffset: currentPageOffset
      };
    });
  }, 100);

  useEffect(() => {
    if (!isDisabled) {
      window.addEventListener("scroll", handleScrollData);
    } else {
      window.removeEventListener("scroll", handleScrollData);
    }

    return () => window.removeEventListener("scroll", handleScrollData);
  }, [isDisabled, setScrollData]);

  return scrollData;
};

export default useScrollListener;
